<section class="add-charges">
  <!-- <h2>
    <mat-icon style="vertical-align: sub;">payments</mat-icon>
    {{ formMetaData?.formName || 'Add Charge' }}
  </h2>
  <p>{{ formMetaData?.formDescription }}</p> -->

  <mat-card class="form-card">
    @if (!loading) {
    <app-dynamic-forms-v2 [formMetaData]="formMetaData" [formFields]="formFields"
      (formSubmitted)="onFormSubmit($event)">
    </app-dynamic-forms-v2>
    } @else {
    <div class="loading-state">
      <mat-icon>hourglass_empty</mat-icon>
      <p>Loading form fields...</p>
    </div>
    }
  </mat-card>
</section>